import { render, staticRenderFns } from "./BusinessRegistrationCertificate.vue?vue&type=template&id=c946b242&scoped=true&"
import script from "./BusinessRegistrationCertificate.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistrationCertificate.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegistrationCertificate.vue?vue&type=style&index=0&id=c946b242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c946b242",
  null
  
)

export default component.exports